import { type Config } from "./types";

export async function fetchConfig() {
	const config = await fetch(import.meta.env.VITE_DEV === "true" ? "http://localhost:3001/config" : "/config");

	if (!config.ok) throw new Error("Failed to fetch config");

	const configJson = await config.json();
	const parsedConfig: Config = { ...configJson };

	return parsedConfig;
}
